// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "59db9d08add8b445d44980fc2a3563ee" + ".js";
};